export const GET_TAGS = 'GET_TAGS';
export const SUCCESS_GET_TAGS = 'SUCCESS_GET_TAGS';
export const FAIL_GET_TAGS = 'FAIL_GET_TAGS';

export const CREATE_TAG = 'CREATE_TAG';
export const SUCCESS_CREATE_TAG = 'SUCCESS_CREATE_TAG';
export const FAIL_CREATE_TAG = 'FAIL_CREATE_TAG';

export const UPDATE_TAG = 'UPDATE_TAG';
export const SUCCESS_UPDATE_TAG = 'SUCCESS_UPDATE_TAG';
export const FAIL_UPDATE_TAG = 'FAIL_UPDATE_TAG';

export const CREATE_PUSH_MESSAGE = 'CREATE_PUSH_MESSAGE';
export const SUCCESS_PUSH_MESSAGE = 'SUCCESS_PUSH_MESSAGE';
export const FAIL_PUSH_MESSAGE = 'FAIL_PUSH_MESSAGE';

export const GET_PUSH_MESSAGES = 'GET_PUSH_MESSAGES';
export const SUCCESS_GET_PUSH_MESSAGES = 'SUCCESS_GET_PUSH_MESSAGES';
export const FAIL_GET_PUSH_MESSAGES = 'FAIL_GET_PUSH_MESSAGES';

export const INIT_MASTER = 'INIT_MASTER';
